import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import "./styles/index.css"

// temporary redirect from double encoded URLs to fixed ones
const url = window.location.href;
if (url.indexOf("/collections/") > -1 && url.indexOf("%2520") > -1) {
    const newUrl = url.replaceAll("%2520", "+");
    window.history.replaceState({}, "", newUrl);
}

let isMobile = window.innerWidth < 769; 
let inputSelector;

if (isMobile){
    inputSelector = "#bc-sf-search-box-0";
}else{
    inputSelector = "#bc-sf-search-box-1";
}

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#bc-sf-search-box-1",
    contentCssSelector: ".main-content",

    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    
    formCssSelector: 'form#search-form',
    

    // Uncomment to redirect to search page instead of rendering on the same page
    //serpPath: '/pages/search-results',
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,

    serpQuery: {
        products: {
            // fields: [
            // "productId",
            //  "url",
            // "name",
            // "imageUrl",
            // "thumbUrl",
            // "description",
            // "brand",
            // "availability",
            // "price",
            // "priceText",
            // "listPrice",
            // "ratingValue",
            // "reviewCount",
            // 'customFields.key', 
            // 'customFields.value'
            // ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        },
        categories: {
            size: defaultConfig.autocompleteCategoriesSize,
            from: 0,
            emptyQueryMatchesAll: true,
        },
    },

    compressUrlParameters: true,

    // // Uncomment for Category Merchandising

    categoryCssSelector: "#nosto-cm, .template-collection__body",
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
    persistentSearchCache: true
}).then(function(){
    jQuery(".search-main-icon").on("click", function(){
        setTimeout(() => {
            jQuery("#bc-sf-search-box-1").focus()
        }, 500);
    })
})

